$(function () {
  // Hero Carousel
  if ($(".carousel-wrapper").length > 0) {
    $(".carousel-wrapper").not(".slick-initialized").slick({
      dots: true,
      speed: 300,
      arrows: false,
      appendDots: ".slider-dots",
      slidesToShow: 1,
      swipeToSlide: true,
      autoplay: true,
      touchThreshold: 20,
      autoplaySpeed: 8000,
      infinite: true,
    });
    $(".slider-dots button").empty();
  }

  // Client Logo Slider
  if ($(".client-logoSlider").length > 0) {
    $(".client-logoSlider")
      .not(".slick-initialized")
      .each(function () {
        $(this).slick({
          dots: false,
          speed: 300,
          slidesToShow: 5,
          autoplay: true,
          autoplaySpeed: 8000,
          swipeToSlide: true,
          touchThreshold: 20,
          adaptiveHeight: true,
          // variableWidth: true,
          // centerMode: true,
          // centerPadding: '0px',
          infinite: true,
          appendArrows: $(this).next(".slider-controls"),
          prevArrow: '<i class="icon ion-ios-arrow-left sl-left"></i>',
          nextArrow: '<i class="icon ion-ios-arrow-right sl-right"></i>',
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 5,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 4,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 3,
              },
            },
          ],
        });
      });
  }

  // Client Logo Slider
  if ($(".client-logoSlider_new").length > 0) {
    $(".client-logoSlider_new")
      .not(".slick-initialized")
      .each(function () {
        $(this).slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          autoplay: false,
          dots: false,
          // speed: 300,
          // slidesToShow: 4,
          // autoplay: false,
          // autoplaySpeed: 8000,
          // swipeToSlide: true,
          // touchThreshold: 20,
          // adaptiveHeight: true,
          // variableWidth: true,
          centerMode: true,
          centerPadding: '0px',
          // infinite: true,
          appendArrows: $(this).next(".slider-controls"),
          prevArrow: '<i class="icon ion-ios-arrow-left sl-left"></i>',
          nextArrow: '<i class="icon ion-ios-arrow-right sl-right"></i>',
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 5,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 4,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 3,
              },
            },
          ],
        });
      });
  }

  // Testimonial Carousel
  if ($(".testimonialCarousel").length > 0) {
    $(".testimonialCarousel").slick({
      dots: true,
      speed: 300,
      slidesToShow: 1,
      appendDots: ".testimonial-dots",
      autoplay: true,
      swipeToSlide: true,
      autoplaySpeed: 8000,
      infinite: true,
      arrows: false,
    });
    $(".slider-dots button").empty();
  }

  // Gallery Carousel
  if ($(".galleryCarousel").length > 0) {
    $(".galleryCarousel").slick({
      dots: true,
      speed: 300,
      slidesToShow: 1,
      touchThreshold: 20,
      appendDots: ".gallery-dots",
      autoplay: true,
      swipeToSlide: true,
      autoplaySpeed: 8000,
      infinite: true,
      arrows: false,
    });
    $(".slider-dots button").empty();
  }

  // Home Case Study Carousel
  if ($(".home-cs__slider").length > 0) {
    $(".home-cs__slider").slick({
      dots: true,
      speed: 300,
      autoplay: true,
      swipeToSlide: true,
      slidesToShow: 1,
      touchThreshold: 20,
      autoplaySpeed: 8000,
      appendDots: ".home-cs .slider-navigation",
      variableWidth: true,
      infinite: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            centerMode: true,
          },
        },
      ],
    });
    $(".home-cs__slider .slick-dots button").empty();

    $(".home-cs .next-slide").on("click", function () {
      $(".home-cs__slider").slick("slickNext");
    });
  }

  // Home Insights Carousel
  if ($(".home-insights__slider").length > 0) {
    $(".home-insights__slider").slick({
      dots: true,
      speed: 450,
      autoplay: true,
      swipeToSlide: true,
      slidesToShow: 1,
      touchThreshold: 20,
      autoplaySpeed: 8000,
      appendDots: ".home-insights .slider-navigation",
      infinite: true,
      arrows: false,
    });
    $(".home-insights .next-slide").on("click", function () {
      $(".home-insights__slider").slick("slickNext");
    });
  }

  // Home Testimonials Carousel
  if ($(".home-testimonials__slider").length > 0) {
    $(".home-testimonials__slider").slick({
      dots: true,
      speed: 300,
      autoplay: true,
      swipeToSlide: true,
      slidesToShow: 4,
      centerMode: true,
      appendDots: ".home-testimonials .slider-navigation",
      touchThreshold: 20,
      autoplaySpeed: 8000,
      infinite: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    });
  }
});



// WEBPACK FOOTER //
// ./scripts/components/sliders.js